// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { BallBounceDataWire, BallBounceDataWireT } from '../mannequin/ball-bounce-data-wire';
import { BallHitDataWire, BallHitDataWireT } from '../mannequin/ball-hit-data-wire';
import { BallHitLaunchWire, BallHitLaunchWireT } from '../mannequin/ball-hit-launch-wire';
import { BallHitRefinedWire, BallHitRefinedWireT } from '../mannequin/ball-hit-refined-wire';
import { BallPitchDataWire, BallPitchDataWireT } from '../mannequin/ball-pitch-data-wire';
import { BallPitchRefinedWire, BallPitchRefinedWireT } from '../mannequin/ball-pitch-refined-wire';
import { BallThrowData, BallThrowDataT } from '../mannequin/ball-throw-data';


export enum BallPolynomialDataWire {
  NONE = 0,
  BallBounceDataWire = 1,
  BallHitDataWire = 2,
  BallHitLaunchWire = 3,
  BallHitRefinedWire = 4,
  BallPitchDataWire = 5,
  BallPitchRefinedWire = 6,
  BallThrowData = 7
}

export function unionToBallPolynomialDataWire(
  type: BallPolynomialDataWire,
  accessor: (obj:BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData) => BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData|null
): BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData|null {
  switch(BallPolynomialDataWire[type]) {
    case 'NONE': return null; 
    case 'BallBounceDataWire': return accessor(new BallBounceDataWire())! as BallBounceDataWire;
    case 'BallHitDataWire': return accessor(new BallHitDataWire())! as BallHitDataWire;
    case 'BallHitLaunchWire': return accessor(new BallHitLaunchWire())! as BallHitLaunchWire;
    case 'BallHitRefinedWire': return accessor(new BallHitRefinedWire())! as BallHitRefinedWire;
    case 'BallPitchDataWire': return accessor(new BallPitchDataWire())! as BallPitchDataWire;
    case 'BallPitchRefinedWire': return accessor(new BallPitchRefinedWire())! as BallPitchRefinedWire;
    case 'BallThrowData': return accessor(new BallThrowData())! as BallThrowData;
    default: return null;
  }
}

export function unionListToBallPolynomialDataWire(
  type: BallPolynomialDataWire, 
  accessor: (index: number, obj:BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData) => BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData|null, 
  index: number
): BallBounceDataWire|BallHitDataWire|BallHitLaunchWire|BallHitRefinedWire|BallPitchDataWire|BallPitchRefinedWire|BallThrowData|null {
  switch(BallPolynomialDataWire[type]) {
    case 'NONE': return null; 
    case 'BallBounceDataWire': return accessor(index, new BallBounceDataWire())! as BallBounceDataWire;
    case 'BallHitDataWire': return accessor(index, new BallHitDataWire())! as BallHitDataWire;
    case 'BallHitLaunchWire': return accessor(index, new BallHitLaunchWire())! as BallHitLaunchWire;
    case 'BallHitRefinedWire': return accessor(index, new BallHitRefinedWire())! as BallHitRefinedWire;
    case 'BallPitchDataWire': return accessor(index, new BallPitchDataWire())! as BallPitchDataWire;
    case 'BallPitchRefinedWire': return accessor(index, new BallPitchRefinedWire())! as BallPitchRefinedWire;
    case 'BallThrowData': return accessor(index, new BallThrowData())! as BallThrowData;
    default: return null;
  }
}
